




































import { Component, Vue, Prop } from 'vue-property-decorator';
import { overtenThousand } from '@/utils'

@Component({
  components: {
  },
})
export default class AnchorCard extends Vue {
  private sid!: string
  private loadingInstance: any
  private hideFollow = false

  private mounted() {
    const { hideFollow } = this.$route.query
    this.hideFollow = hideFollow === '1'
    console.log('info card:', this.userImg)
  }

  private get anchorDeatil () {
    return this.$store.state.anchorDeatil
  }

  private get author () {
    return this.$store.state.currentAuthor
  }

  private get giftCount () {
    return overtenThousand(this.$store.state.liveRoomInteractionInfo.giftCount)
  }

  private get userImg() {
    return this.anchorDeatil.userImg || this.$store.state.currentAuthor.anchorPhoto
  }

  private withLogin (func) {
    if (this.$store.state.userInfo.isTourist) {
      this.$weui.dialog({
        title: '提示',
        content: '请先登录',
        buttons: [{
            label: '确定',
            type: 'primary',
            onClick: () => {console.log('确定')}
        }]
      })
      return
    }
    func()
  }

  private get isFollow () {
    return +this.$store.state.anchorDeatil.isFollow === 1
  }

  private async subAuthor () {
    this.$store.dispatch('updateAuthorDetail')
  }
}
